import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-titled-input',
  imports: [ReactiveFormsModule, NgClass, NgIf],
  templateUrl: './titled-input.component.html',
  styleUrl: './titled-input.component.scss',
})
export class TitledInputComponent {
  @Input() type: 'top' | 'right' = 'top';
  @Input() title = '';
  @Input() control!: FormControl;

  get isInvalid(): boolean{
    return this.control.invalid && (this.control.touched || this.control.dirty);
  }

  get isDisabled(): boolean {
    return this.control.disabled;
  }

  get errorMessage(): string{
    return this.control.errors?.["message"];
  }
}
